import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { allSeccionesAction } from '../SeccionesAction';

const SelectFieldSeccionesComponent = ({
  onChange,
  value = '',
  data,
  id = 'select-secciones',
  isAll = true,
  isAllText = false,
  isEmpty = false,
  selects = [],
  required = false,
  error = false,
  width = '100%',
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const seccionesStore = Redux.useSelector((state) => state.secciones);

  // Ordenamiento sin mutar el arreglo original
  const sortSecciones = React.useCallback((items) => {
    const list = Array.isArray(items) ? [...items] : [];
    return list.sort((a, b) => {
      const nivelA = a?.nivelAcademico?.nivelAcademico || {};
      const nivelB = b?.nivelAcademico?.nivelAcademico || {};

      const categoriaA = nivelA?.categoria || '';
      const categoriaB = nivelB?.categoria || '';
      const tipoComparison = categoriaA.localeCompare(categoriaB);

      if (tipoComparison !== 0) return tipoComparison;

      const numeroA = Number(nivelA?.numero) || 0;
      const numeroB = Number(nivelB?.numero) || 0;
      return numeroA - numeroB;
    });
  }, []);

  // Lista de secciones derivada (filtrada y ordenada)
  const secciones = React.useMemo(() => {
    const base = data ?? seccionesStore.all ?? [];
    const filtered =
      selects.length > 0
        ? base.filter(
            (seccion) => !selects.some((item) => item.id === seccion.id),
          )
        : base;
    return sortSecciones(filtered);
  }, [data, seccionesStore.all, selects, sortSecciones]);

  React.useEffect(() => {
    if (
      !data &&
      Array.isArray(seccionesStore.all) &&
      seccionesStore.all.length === 0 &&
      entidadesStore?.activo?.id
    ) {
      allSeccionesAction(dispatch, { idEntidad: entidadesStore.activo.id });
    }
  }, [data, seccionesStore.all, entidadesStore?.activo?.id, dispatch]);

  return (
    <FormControl fullWidth size="small" required={required} error={error}>
      <InputLabel id={`label_${id}`}>{CONST.seccion.label}</InputLabel>
      <Select
        id={id}
        value={value?.toString?.() ?? ''}
        labelId={`label_${id}`}
        label={CONST.seccion.label}
        onChange={(e) => onChange(e.target.value)}
        sx={{ width }}
      >
        {!isEmpty && isAll && (
          <MenuItem key={`item_${id}_000`} value="">
            {isAll ? 'TODOS' : 'NINGUNO'}
          </MenuItem>
        )}

        {isAllText && (
          <MenuItem key={`item_${id}_all`} value={'all'}>
            TODOS
          </MenuItem>
        )}

        {secciones.map((el) => {
          return (
            <MenuItem key={`item_${id}_${el.id}`} value={el.id}>
              {el?.nivelAcademico?.nivelAcademico?.abrev}
              {', '}
              <strong>Mensión:</strong> {el?.carrera?.carrera?.abrev}
              {', '}
              <strong>Sección:</strong> {el?.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default React.memo(SelectFieldSeccionesComponent);
